export default __webpack_public_path__ + "static/media/neptune.6395ae25.png";